export default {
    customer_order_information: $localize `Customer order information`, // done
    customer_employee_confimed_notification: $localize `Customer partner confirmed notification`, // done
    customer_coming_up_notification: $localize `Customer coming up notification`, // done
    customer_checkin_notification: $localize `Customer checkin notification`, // done
    customer_checkout_notification: $localize `Customer checkout notification`,
    employee_order_information: $localize `Partner order information`, // done
    employee_new_order_notification: $localize `Partner new order notification`, // done
    employee_coming_up_notification: $localize `Partner coming up notification`, // done
}